import {PayloadAction} from "../payload-action.interface";
import {ContactEntity} from "./contact.entity";
import {ContactActions} from "./contact.actions";


export function ContactReducer(state: Array<ContactEntity> = [], action: PayloadAction) {
  let newState;

  switch (action.type) {
    case ContactActions.REMOVE:
      return removeContact(state, action.payload);
    case ContactActions.ADD:
    case ContactActions.SET:
      newState = removeContact(state, action.payload._id);
      return addContact(newState, action.payload);
    case ContactActions.ADD_ALL:
      return [...action.payload];
    default:
      return state;
  }
}

function addContact(state: Array<ContactEntity>, contact: ContactEntity): Array<ContactEntity> {
  return [...state, contact];
}

function removeContact(state: Array<ContactEntity>, id: string): Array<ContactEntity> {
  return state.filter((contact) => contact._id !== id);
}



// WEBPACK FOOTER //
// ./src/store/contact/contact.reducer.ts